import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { TableWrapper, UiList, IconBtn } from '@ru-digital-assets/ui-component';
import { format } from 'date-fns';

import UcpDetailsTop from '../components/ucp-sign/ucp-details-top/ucp-details-top';
import UcpDocs from '../components/ucp-sign/ucp-docs/ucp-docs';
import UcpHeader from '../components/ucp-sign/ucp-header/ucp-header';
import UcpSignForm from '../components/ucp-sign/ucp-sign-form/ucp-sign-form';
import LoadDocBtn from '../modules/load-doc-btn';
import { useAppDispatch } from '../store';
import {
  getPurchase,
  getAgreementDoc,
  setSigningInfo,
  signPurchase,
} from '../store/actions/operations-sign';
import { setOperationResult } from '../store/actions/sign-result';
import { RootState } from '../types';
import { downloadFile } from '../utils/files/downloadFile';
import { OperationComplete } from 'components';
import { BuyParameters } from 'components';
import { useSign } from 'hooks';

const AssetsBuyingSignContainer: React.FC = () => {
  const history = useHistory();
  const { id } = history.location?.state;

  const dispatch = useAppDispatch();

  const buying: any = useSelector(
    (state: RootState) => state.operationsSign.data.buyingCfa
  );
  const purchase: any = useSelector(
    (state: RootState) => state.operationsSign.data.purchase
  );

  console.log("purchase", purchase);
  console.log("buying", buying)

  const buyingCfa = buying.id ? buying : purchase;

  console.log('buyingCfa', buyingCfa);

  const decisionId = buyingCfa.decisionId;

  const decisionHash = buyingCfa.decisionHash;

  const doc = buyingCfa.decisionDoc;

  console.log("doc", doc);

  const paymentTokens = useSelector(
    (state: RootState) => state.commonInfo.paymentTokens
  );
  const companyInfo = useSelector(
    (state: RootState) => state.companiesInfo.companies
  );

  const [showResultScreen, setShowResultScreen] = useState(false);

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    usersCertificates,
  } = useSign();

  const currentCert = useMemo(() => {
    return usersCertificates.find(
      (certificate) => certificate.thumbprint === selectedCertificate?.value
    );
  }, [usersCertificates, selectedCertificate]);

  const loadingSign = useSelector(
    (state: RootState) => state.operationsSign.loading.buyingCfaSign
  );

  useEffect(() => {
    if (decisionId) {
      dispatch(
        getAgreementDoc({ decisionId, type: 'AGREEMENT', signed: false, withHash: true })
      );
    }
  }, [decisionId]);

  useEffect(() => {
    if (id) {
      dispatch(getPurchase({ id }));
    }
  }, [id]);

  const decisionDocs = useMemo(() => {
    const docs = [];

    if (doc) {
      docs.push(
        <LoadDocBtn
          title="Заявка на покупку ЦФА"
          onSpecDownload={() => {
            // const resultBlob = getPdfFromBase64(doc);
            downloadFile(
              doc,
              'Заявка на покупку ЦФА.pdf',
              'application/pdf'
            );
          }}
        />
      );
    }
    return docs;
  }, [doc]);

  const onClose = () => history.push('/orders');

  const onSubmit = async () => {
    if (currentCert && decisionHash && decisionId) {
      const { pdfSigned } = await signEntity(decisionHash);
      if (pdfSigned) {
        dispatch(
          setSigningInfo({
            thumbprint: currentCert.thumbprint,
            name: currentCert.issuerName,
            date: `с ${format(
              new Date(currentCert.validFrom),
              'dd/MM/yyyy'
            )} до ${format(new Date(currentCert.validTo), 'dd/MM/yyyy')}`,
          })
        );
        dispatch(
          signPurchase({
            info: {
              hash: decisionHash,
              signature: pdfSigned,
              operationId: decisionId,
            },
            callback: () => setShowResultScreen(true),
          })
        ).then(
          (action) => {
            const resultStatus = action.meta.requestStatus === 'fulfilled';
            dispatch(
              setOperationResult({ name: 'buyingCfa', status: resultStatus })
            );
            setShowResultScreen(true);
          },
          () => {
            dispatch(setOperationResult({ name: 'buyingCfa', status: false }));
            history.push('/assets/sign-result');
          }
        );
      }
    }
  };

  const initiatorList = [
    {
      label: 'Покупатель:',
      value: companyInfo[buyingCfa.accountId]?.shortName,
    },
    {
      label: 'ИНН:',
      value: companyInfo[buyingCfa.accountId]?.tin,
    },
  ];

  const recipientList = [
    {
      label: 'Контрагент:',
      value: companyInfo[buyingCfa.companyId]?.shortName,
    },
    {
      label: 'ИНН',
      value: companyInfo[buyingCfa.companyId]?.tin,
    },
  ];

  return (
    <TableWrapper>
      {showResultScreen ? (
        <OperationComplete
          title="Покупка цифровых финансовых активов"
          onClose={() => history.push('/assets')}
          main={
            <>
              <p className="p p_font-size_32 p_font-weight_light mb_32 text-center">
                Заявка на покупку {buyingCfa?.tokenCount} токенов{' '}
                {
                  paymentTokens.find((p) => p.code === buyingCfa?.tokenName)
                    ?.name
                }
              </p>
              <p className="p p_font-size_18 mb_32">
                Ожидайте пока ваше предложение будет принято контрагентом
              </p>
              <div className="flex">
                <IconBtn
                  title="Перейти в операции"
                  onClick={() => history.push('/history')}
                />
              </div>
            </>
          }
        />
      ) : (
        <div className="ucp">
          <UcpHeader onClose={onClose} />
          <div className="ucp__body">
            <div className="ucp__left">
              <UcpDetailsTop
                operationString={`Заявка на покупку ${
                  buyingCfa?.tokenCount
                } токенов "${
                  paymentTokens.find((p) => p.code === buyingCfa?.tokenName)
                    ?.name
                }"`}
              />
              <div className="ucp__content">
                <div className="ucp__ontractors">
                  <h3 className="h3">Детали операции:</h3>
                  <div className="ucp__ontractors-body">
                    <div className="ucp__ontractors__left">
                      <UiList list={initiatorList} sm />
                    </div>
                    <div className="ucp__ontractors__right">
                      <UiList list={recipientList} sm />
                    </div>
                  </div>
                </div>
                <UcpDocs docs={decisionDocs} />
                <UcpSignForm
                  selected={selectedCertificate}
                  onCertSelect={onUserSelectCertificate}
                  onSubmit={onSubmit}
                  disabled={!currentCert || loadingSign}
                  backCallback={() => history.push(`/assets/buying`)}
                  btnText="Подписать заявку"
                  certsList={certificatesList}
                />
              </div>
            </div>
            <div className="ucp__right ucp__right--dynamic">
              <BuyParameters />
            </div>
          </div>
        </div>
      )}
    </TableWrapper>
  );
};

export default AssetsBuyingSignContainer;
